module.exports = __webpack_public_path__ + "static/media/operator-inactive-hub.549bf8be.svg";